<template>
  <section
    class="role-dashboard-view h-[calc(100vh-110px)] overflow-y-auto overflow-x-hidden !rounded-xl bg-container-background"
    id="roleDashboard"
  >
    <div
      class="flex items-center gap-2 flex-wrap justify-start w-full !box-border md:!justify-between bg-container-background top-0 py-2 px-3 border-b border-page-border sticky z-[1]"
    >
      <div class="flex items-center gap-2">
        <el-button
          @click="goBack()"
          size="mini"
          class="bg-transparent !border border-black/20 hover:!border-brand-300 active:!border-brand-500 !py-[6px] !px-2 !rounded-sm hover:!bg-gray-100"
        >
          <span>
            <img src="@/assets/img/icons/new/left-back-icon.svg" alt="" class="!size-3" />
          </span>
        </el-button>
        <h2
          class="!text-sm 2xl:!text-base !font-normal !text-black-950 !m-0 !w-96 truncate flex items-center !gap-1.5"
        >
          <icons :iconName="'dashboard'"></icons>
          <span>Role Management</span>
        </h2>
      </div>

      <el-button
        class="!bg-brand-500 !text-white !border-0 text-xs 2xl:!text-sm !font-normal !rounded-md !leading-normal !h-auto !px-4 !py-1.5"
        type="primary"
        size="medium"
        @click="onAddRole"
      >
        <span class="flex items-center !gap-1">
          <img src="@/assets/img/icons/new/add-icon.svg" alt="" class="!size-3" />

          <span>Add Role</span>
        </span>
      </el-button>
    </div>
    <div class="!px-3 !pt-3">
      <div class="inner-navbar">
        <div class="d-flex align-center space-between mb-10 !font-normal">
          <el-breadcrumb separator-class="el-icon-arrow-right !font-normal">
            <el-breadcrumb-item :to="{ path: '/' }" class="!font-normal !text-black-600">
              Dashboard
            </el-breadcrumb-item>

            <el-breadcrumb-item class="!text-black-500">Roles</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>

      <div class="inner-navbar-content top" v-if="!loading && allRoles.length">
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 !gap-3">
          <div
            :lg="6"
            v-for="(role, index) of allRoles"
            :key="index"
            class="box-card !bg-card-color !border border-card-border !rounded-lg !p-4"
          >
            <div slot="header" class="!mb-4 flex itemx-center justify-between">
              <span class="on-over !text-black-950">
                <!-- {{ role.title| truncate(15, "...") }} -->
                <span :title="role.title.length > 15 ? role.title : ''" class="!text-black-950">
                  {{ role.title | truncate(15, '...') }}
                </span>
              </span>
              <div class="flex items-center !gap-2">
                <template v-if="!role.isSuper">
                  <i class="el-icon-edit on-over !text-black-950" @click="onEditRole(role)"></i>
                  &nbsp;&nbsp;&nbsp;

                  <i class="el-icon-delete on-over !text-black-950" @click="onDeleteRole(role)"></i>
                </template>
              </div>
            </div>
            <div v-if="role.allowed_groups.length">
              <el-tag
                :key="tag"
                v-for="tag in role.allowed_groups"
                :disable-transitions="false"
                :type="getType"
              >
                {{ getGroupName(tag) }}
              </el-tag>
            </div>
          </div>
        </div>

        <el-pagination
          class="!flex items-center justify-center !pt-3 !gap-x-3"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalRoles"
        ></el-pagination>
      </div>

      <div class="inner-navbar-content top" v-else>
        <el-empty description="No Roles" v-if="!loading"></el-empty>

        <template v-else>
          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 !gap-3">
            <div class="box-card !bg-card-color !rounded-lg" v-for="o in 8" :key="o">
              <el-skeleton animated>
                <template slot="template">
                  <el-skeleton-item variant="p" style="width: 50%" />

                  <el-divider class="mt-0 mb-0"></el-divider>

                  <el-skeleton-item />

                  <div style="padding: 14px">
                    <div style="display: flex; align-items: center; justify-items: space-between">
                      <el-skeleton-item variant="text" style="margin-right: 16px" />

                      <el-skeleton-item variant="text" style="width: 30%" />
                    </div>
                  </div>
                </template>
              </el-skeleton>
            </div>
          </div>
        </template>
      </div>
      <AddEditRole
        v-if="showAddEditRole"
        @close="closeAddEditRole"
        :existedRole="selectedRole"
      ></AddEditRole>
    </div>
  </section>
</template>
<script>
  import { mapGetters } from 'vuex';
  import AddEditRole from './AddEditRole';
  import DocumentsHelper from '@/mixins/CompanyDocumentsHelper';
  export default {
    components: {
      AddEditRole,
    },
    data() {
      return {
        loading: false,
        allRoles: [],
        totalRoles: 0,
        showAddEditRole: false,
        selectedRole: {},
        currentPage: 1,
        pageSize: 12,
        allEntitiesGroups: [],
        types: ['success', 'info', 'warning', 'danger'],
      };
    },
    computed: {
      ...mapGetters('roles', ['getAllRoles', 'getSuccess', 'getRoleErrors']),
      ...mapGetters('entityGroups', ['getAllEntityGroupsData']),
      getType() {
        let types = ['success', 'info', 'warning', 'danger'];
        const index = Math.floor(Math.random() * types.length);
        return types[index];
      },
    },
    mounted() {
      this.getCompanyInformation();
      this.fetchRoles(1);
      this.fetAllEntityGroups();
    },
    mixins: [DocumentsHelper],
    methods: {
      goBack() {
        this.$router.push({
          path: '/profile',
        });
      },

      onDeleteRole(role) {
        this.$confirm(`Are you sure to delete the ${role.title} ?`, 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }).then(() => {
          this.deleteRole(role);
        });
      },
      async deleteRole(role) {
        this.loading = true;
        try {
          await this.$store.dispatch('roles/deleteRole', role._id);
          if (this.getSuccess && this.getSuccess.success) {
            this.$notify.success({
              title: 'Success',
              message: `${role.title} deleted successfully`,
            });
            this.fetchRoles(1);
          } else {
            throw this.getRoleErrors;
          }
          setTimeout(() => {
            this.loading = false;
          }, 2000);
        } catch (err) {
          this.$notify.error({
            title: 'Error',
            message: this.getRoleErrors.message || 'Sorry! This Role is associated with Users',
          });
          setTimeout(() => {
            this.loading = false;
          }, 2000);
        }
      },

      getGroupName(id) {
        // let roleWithUserType = this.lodash.filter(
        //   this.allEntitiesGroups,
        //   function (element) {
        //     return element._id === id;
        //   }
        // );
        let roleWithUserType = this.allEntitiesGroups.filter((element) => element._id === id);
        if (roleWithUserType && roleWithUserType.length) {
          return roleWithUserType[0].name;
        } else {
          return 'E-SIGNS';
        }
      },
      async fetAllEntityGroups() {
        this.loading = true;
        let params = {
          get_all: true,
        };
        await this.$store.dispatch('entityGroups/fetEntityGroupsData', params);
        this.allEntitiesGroups = this.getAllEntityGroupsData
          ? this.getAllEntityGroupsData.data
          : [];
        this.loading = false;
      },
      handleCurrentChange(page) {
        this.fetchRoles(page);
      },

      async fetchRoles(page) {
        this.loading = true;
        let params = {
          page: page,
          limit: this.pageSize,
          order_by: 'name',
          order_type: 'asc',
          skip: 0,
        };
        await this.$store.dispatch('roles/fetchRoles', params);
        this.allRoles = this.getAllRoles ? this.getAllRoles.data : [];
        this.totalRoles = this.getAllRoles.total;
        this.currentPage = parseInt(this.getAllRoles.page);
        setTimeout(() => {
          this.loading = false;
        }, 1500);
      },
      onAddRole() {
        this.showAddEditRole = true;
        this.selectedRole = {};
      },
      onEditRole(role) {
        this.selectedRole = role;
        this.showAddEditRole = true;
      },

      async closeAddEditRole(status) {
        this.showAddEditRole = false;
        if (status) {
          await this.fetchRoles(1);
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .role-dashboard-view {
    .add-button {
      padding: 0.45em 0.65em;
      color: rgb(81, 161, 0);

      &:hover {
        background-color: rgb(81, 161, 0);
        color: #ffffff;
        border-color: rgb(81, 161, 0);
      }
    }

    .inner-navbar-content {
      margin-top: 20px;
    }

    .role-box {
      margin-bottom: 15px;

      .role-title {
        height: 45px;
        font-size: 1.1em;
      }

      .actions-btn {
        .each-btn {
          padding: 2px 5px;
          margin-left: 8px;
          border: 1px solid #efefef;
          border-radius: 3px;

          &:hover {
            background-color: #ffffff;
            border: 1px solid #dddddd;
          }

          i {
            font-size: 1.1em;
          }
        }
      }

      .entities-count {
        .count {
          font-size: 1.1em;
          line-height: 1;
        }
      }
    }

    .on-over:hover {
      cursor: pointer;
    }

    .font-semi-bold {
      font-weight: 400;
    }

    .el-tag + .el-tag {
      margin: 0.2rem;
    }
  }

  .el-button--primary {
    height: 32px !important;
  }

  @media (max-width: 670px) {
    .default-button {
      margin-top: 10px;
    }
  }
</style>

<style lang="scss"></style>
